<template>
  <div class="grid-table-row overflow-hidden" :class="{ 'grayed': isGrayedOut, 'error' : isError }" @click.prevent.stop="downloadFile">
    <div class="item__status"><b-badge class="text-uppercase d-inline small" :variant="modsTable[mod.status]">{{ mod.status.toUpperCase() }}</b-badge></div>
    <div class="item__class"><span class="font-condensed">{{ mod.campaign_code }}</span></div>
    <div class="item__code"><span class="font-condensed">{{ mod.field_modification_code.toUpperCase() }}</span></div>
    <div class="item__description"><span class="font-condensed">{{ mod.description }}</span></div>
    <div class="item__date"><span class="d-inline d-md-none mr-1">{{ 'expiresOnLabel' | translate(labels, 'CommonDateTime') }}</span>{{ new Date(mod.end_date) | formatDate }}</div>
    <div class="item__download">
      <b-link :class="{'text-gray' : isError}" :disabled="isError">
        <b-icon icon="download" />
      </b-link>
      <b-tooltip v-if="isError"
                 custom-class="d-none d-sm-block"
                 variant="danger"
                 noninteractive
                 :target="() => $el"
                 :title="translatedLabel('downloadError', 'CommonErrors')"
      />
      <b-tooltip v-else
                 custom-class="d-none d-sm-block"
                 triggers="hover"
                 variant="light"
                 noninteractive
                 :target="() => $el"
                 :title="translatedLabel('downloadDetails', 'FieldMods')"
      />
    </div>
  </div>
</template>

<script>
import {MODS_TABLE} from '@/components/common/FieldMods/FieldModsComponent'
import {bdService} from '@/services'

export default {
  conceptName: ['FieldMods', 'CommonErrors', 'CommonDateTime'],
  props: {
    mod: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      modsTable: MODS_TABLE,
      isError: false
    }
  },
  computed: {
    isGrayedOut() {
      return this.mod.status.toUpperCase() !== 'PENDING'
    }
  },
  methods: {
    downloadFile() {
      bdService.fetchServiceLetters(this.mod.field_modification_code).then(download_link => {
        const win = window.open(download_link, '_blank')
        win.focus()
      }).catch(() => {
        this.isError = true
      })
    }
  }
}
</script>
